import React from 'react';
import classnames from 'classnames/bind';
import { Text } from '@gasbuddy/react-components';
import hdate from 'human-date';

import {
  getMemberPriceStampInfoFromMemberName,
  isValidPrice,
  priceFormatter,
} from '../../../lib/utils';
import PricePropType from '../../prop-types/price';
import styles from './FuelTypePriceDisplay.module.css';

const cx = classnames.bind(styles);

export default function FuelTypePriceDisplay({ priceReport }) {
  const priceStampInfo = getMemberPriceStampInfoFromMemberName(priceReport.reportedBy);
  const isValidPriceReport = isValidPrice(priceReport);

  return (
    <div className={cx('displayContainer')}>
      <Text bold className={cx('price')} size="xl">
        {
          isValidPriceReport
            ? priceFormatter(priceReport.price)
            : '- - -'
        }
      </Text>

      { isValidPriceReport && (
        <div className={cx('reportedBy', 'reportedGrey')}>
          <a href={priceStampInfo.linkUrl}>
            <Text className={cx('reportedGrey')} size="sm">
              <img src={priceStampInfo.iconPath} alt="Member Icon" />
              &nbsp;
              {priceReport.reportedBy}
            </Text>
          </a>
          <br />
          <Text as="p" className={cx('reportedTime', 'reportedGrey')} size="sm">
            {hdate.relativeTime(priceReport.postedTime)}
          </Text>
        </div>
      )}
    </div>
  );
}

FuelTypePriceDisplay.propTypes = {
  priceReport: PricePropType.isRequired,
};
